import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { marketProspect } from '@/mocks/invest';

export default function MarketProspect() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="市场前景"
            title="四大增长引擎，打开县域数字商业蓝海"
            subtitle="乡村数字经济、县域商业体系、农产品上行与数据要素价值，共同构成九畴云铺的市场空间。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          {marketProspect.map((m, i) => (
            <Reveal key={m.title} delay={i * 80}>
              <div className="h-full p-6 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors">
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center">
                    <i className={`${m.icon} text-primary-600 text-2xl`}></i>
                  </div>
                  <span className="font-heading font-bold text-xl text-accent-600 whitespace-nowrap">
                    {m.value}
                  </span>
                </div>
                <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950">{m.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{m.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}